import '@src/styles/components/customModal.scss';
import PropTypes from 'prop-types';

const CustomButtonHover = ({ index, setIsHovered, clickButton, children }) => {
  return (
    <button
      onMouseEnter={() => setIsHovered(index)}
      onMouseLeave={() => setIsHovered(-1)}
      style={{
        backgroundColor: 'transparent',
        borderWidth: 0,
      }}
      onClick={clickButton}
    >
      {children}
    </button>
  );
};

CustomButtonHover.propTypes = {
  index: PropTypes.number,
  setIsHovered: PropTypes.func,
  clickButton: PropTypes.func,
  children: PropTypes.any,
};

export default CustomButtonHover;
